import React, { useRef } from 'react'
import ColAtm from "../../../../atomic/Col/Col";
import {useForm} from "react-hook-form";
import LabelAtm from "../../../../atomic/Label/Label";
import PasswordInput from "../../../../molecules/PasswordInput/PasswordInput";
import {useTranslation} from "react-i18next";

const UpdatePasswordForm  = (props) => {
    const { register, handleSubmit,  errors, watch} = useForm({
        mode: "onChange",
        reValidateMode: 'onChange',
    });
    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = (data) => {
        props.updatePassword(data)
    }

    const { t } = useTranslation();

    return(
        <ColAtm container  direction="row" md={6} className="m-auto">
            <form onSubmit={handleSubmit(onSubmit)} className="edit-profile-form" name="general-form" id="general-form" >
                <LabelAtm variant="h6" component="h2" text={ t('enw-update-password-subtitle') } />
                <PasswordInput
                    name="old_password"
                    label={ t('enw-input-password') }
                    autoComplete="current-password"
                    error={errors.old_password}
                    inputRef={register({ required:  t("enw-notification_this_is_required") })}
                />
                <PasswordInput
                    name="password"
                    label={ t('enw-input-new_password') }
                    autoComplete="new-password"
                    error={errors.password}
                    inputRef={register({
                        required: "You must specify a password",
                        minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters"
                        }
                    })}
                />
                <PasswordInput
                    name="password_confirmation"
                    label={ t('enw-input-re_enter_your_new_password') }
                    autoComplete="new-password"
                    error={errors.password_confirmation}
                    inputRef={register({
                        validate: value =>
                            value === password.current || "The passwords do not match"
                    })}
                />
            </form>
        </ColAtm>
    )

}

export default UpdatePasswordForm;
